import React from 'react';
import {Link} from 'react-router-dom';
import {useAuth} from '../hooks/useAuth';

const Home = () => {
    const {currentUser} = useAuth();

    return (
        <div className="bg-gray-50 min-h-screen">
            {/* Hero Section */}
            <div className="relative bg-indigo-600 overflow-hidden">
                <div className="max-w-7xl mx-auto">
                    <div
                        className="relative z-10 pb-8 bg-indigo-600 sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32">
                        <div className="relative pt-6 px-4 sm:px-6 lg:px-8">
                            <nav className="relative flex items-center justify-between sm:h-10">
                                <div className="flex items-center flex-grow flex-shrink-0 lg:flex-grow-0">
                                    <div className="flex items-center justify-between w-full md:w-auto">
                                        <span className="text-white text-2xl font-bold">Registre JEE/SIM</span>
                                    </div>
                                </div>
                                <div className="hidden md:block md:ml-10 md:pr-4 md:space-x-8">
                                    {currentUser ? (
                                        <Link to="/dashboard" className="font-medium text-white hover:text-gray-200">
                                            Mon espace
                                        </Link>
                                    ) : (
                                        <Link to="/login"
                                              className="font-medium text-white hover:text-gray-200 border border-white px-4 py-2 rounded-md">
                                            Administration
                                        </Link>
                                    )}
                                </div>
                            </nav>
                        </div>

                        <main
                            className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
                            <div className="sm:text-center lg:text-left">
                                <h1 className="text-4xl tracking-tight font-extrabold text-white sm:text-5xl md:text-6xl">
                                    <span className="block">Recensement Officiel</span>
                                    <span className="block text-indigo-200">des Jeunes de l'EE/SIM</span> <b
                                    className={"text-yellow-400"}>PROVINCE DU
                                    KADIOGO</b>
                                </h1>
                                <p className="mt-3 text-base text-indigo-100 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                                    Bienvenue sur la plateforme de recensement de la Jeunesse Évangélique de l'Église
                                    SIM. Faites-vous recenser pour être officiellement enregistré comme membre de notre
                                    communauté.
                                </p>
                                <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                                    <div className="rounded-md shadow">
                                        <Link to="/recensement"
                                              className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-indigo-700 bg-white hover:bg-gray-50 md:py-4 md:text-lg md:px-10">
                                            Je me fais recenser
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
                <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                    <div className="h-56 w-full bg-indigo-800 sm:h-72 md:h-96 lg:w-full lg:h-full"></div>
                </div>
            </div>

            {/* Pourquoi se faire recenser */}
            <div className="py-12 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="lg:text-center">
                        <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">Pourquoi se
                            faire recenser ?</h2>
                        <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                            Un geste simple pour renforcer notre communauté
                        </p>
                        <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
                            Le recensement nous permet de mieux vous connaître et d'adapter nos activités à vos besoins.
                        </p>
                    </div>

                    <div className="mt-10">
                        <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <div
                                        className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none"
                                             viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                  d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">Accès aux
                                        informations</h3>
                                    <p className="mt-2 text-base text-gray-500">
                                        Recevez des informations importantes concernant les activités et les événements
                                        de notre communauté.
                                    </p>
                                </div>
                            </div>

                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <div
                                        className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none"
                                             viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                  d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">Appartenance</h3>
                                    <p className="mt-2 text-base text-gray-500">
                                        Faites officiellement partie de notre communauté et participez à son
                                        développement.
                                    </p>
                                </div>
                            </div>

                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <div
                                        className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none"
                                             viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                  d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">Communication</h3>
                                    <p className="mt-2 text-base text-gray-500">
                                        Recevez des messages importants et restez informé des activités et événements à
                                        venir.
                                    </p>
                                </div>
                            </div>

                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <div
                                        className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                                        <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none"
                                             viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                  d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/>
                                        </svg>
                                    </div>
                                </div>
                                <div className="ml-4">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">Participation aux
                                        activités</h3>
                                    <p className="mt-2 text-base text-gray-500">
                                        Participez plus facilement aux activités organisées par la JEE/SIM et soyez
                                        informé en priorité.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Comment ça marche */}
            <div className="bg-indigo-50 py-12">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="lg:text-center">
                        <h2 className="text-base text-indigo-600 font-semibold tracking-wide uppercase">Comment ça
                            marche ?</h2>
                        <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                            Simple et rapide en 3 étapes
                        </p>
                    </div>

                    <div className="mt-10">
                        <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10">
                            <div className="text-center">
                                <div
                                    className="flex items-center justify-center h-16 w-16 rounded-full bg-indigo-500 text-white text-2xl font-bold mx-auto">
                                    1
                                </div>
                                <h3 className="mt-4 text-lg leading-6 font-medium text-gray-900">Inscription</h3>
                                <p className="mt-2 text-base text-gray-500">
                                    Remplissez le formulaire de recensement avec vos informations personnelles.
                                </p>
                            </div>

                            <div className="text-center">
                                <div
                                    className="flex items-center justify-center h-16 w-16 rounded-full bg-indigo-500 text-white text-2xl font-bold mx-auto">
                                    2
                                </div>
                                <h3 className="mt-4 text-lg leading-6 font-medium text-gray-900">Validation</h3>
                                <p className="mt-2 text-base text-gray-500">
                                    Votre église d'appartenance valide votre inscription.
                                </p>
                            </div>

                            <div className="text-center">
                                <div
                                    className="flex items-center justify-center h-16 w-16 rounded-full bg-indigo-500 text-white text-2xl font-bold mx-auto">
                                    3
                                </div>
                                <h3 className="mt-4 text-lg leading-6 font-medium text-gray-900">Confirmation</h3>
                                <p className="mt-2 text-base text-gray-500">
                                    Vous recevez une confirmation et faites désormais partie de notre base de données.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section */}
            <div className="bg-white">
                <div
                    className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
                    <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                        <span className="block">Prêt à rejoindre officiellement la communauté JEE/SIM ?</span>
                        <span className="block text-indigo-600">Faites-vous recenser dès aujourd'hui</span>
                    </h2>
                    <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
                        <div className="inline-flex rounded-md shadow">
                            <Link to="/recensement"
                                  className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700">
                                Je me fais recenser
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-gray-800">
                <div className="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
                    <div className="text-center">
                        <p className="text-base text-gray-400">
                            Pour toute assistance, veuillez contacter votre responsable local JEE/SIM
                        </p>
                        {currentUser ? (
                            <p className="mt-2 text-base text-indigo-300">
                                <Link to="/dashboard" className="hover:text-indigo-100">Accès administrateur</Link>
                            </p>) : (
                            <p className="mt-2 text-base text-indigo-300">
                                <Link to="/login" className="hover:text-indigo-100">Accès administrateur</Link>
                            </p>
                        )}
                    </div>
                    <p className="mt-2 text-center text-base text-gray-400">
                        &copy; {new Date().getFullYear()} Registre JEE/SIM. Tous droits réservés. Propulsé par
                        : <a href={'https://www.yandoama.com'} target={'_blank'} rel={'noreferrer'}>Yandoama
                        Consulting</a>
                    </p>
                </div>
            </footer>
        </div>
    );
};

export default Home;
